export default __webpack_public_path__ + "static/media/YoutubeLogo.19f8e494.png";